export default "__VITE_ASSET__Ba15ZUGK__"